"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var ShopContext_1 = require("./ShopContext");
var hooks_1 = require("preact/hooks");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var CtaButton_1 = require("../common/Btn/CtaButton");
var ShopCta = function (_a) {
    var _b;
    var prices = _a.prices;
    var _c = (0, hooks_1.useContext)(ShopContext_1.default), colors = _c.colors, handleAddToCart = _c.handleAddToCart, purchaseTypeIndex = _c.purchaseTypeIndex, options = _c.options, optionIndex = _c.optionIndex, quantityIndex = _c.quantityIndex;
    var isNewVisitor = function () {
        var cookie = {};
        //parse through document and push each cookie into array
        document.cookie.split(';').forEach(function (el) {
            var splitCookie = el.split('=');
            var key = splitCookie[0].trim();
            var value = splitCookie[1];
            cookie[key] = value;
        });
        try {
            //extract unix timestamp of ga cookie
            var cookieDate = cookie['_ga'].substring(cookie['_ga'].length - 10);
            var timeDiff = Math.floor(Date.now() / 1000) - parseInt(cookieDate);
            //if time between cookie set and current date is more than 40, they are returning visitor
            return timeDiff < 2400;
        }
        catch (e) {
            console.error(e);
        }
        return true;
    };
    var _d = (0, hooks_1.useState)(window.localStorage.getItem('bannerEnd') == 'true'), bannerEnd = _d[0], setBannerEnd = _d[1];
    var discount = bannerEnd ? '15OFF' : 'NEW25';
    var percent = bannerEnd ? 0.15 : 0.25;
    var discountPrice = prices.price && (Number(prices.price.amount) * (1 - percent)).toFixed(2);
    (0, hooks_1.useEffect)(function () {
        if (!isNewVisitor()) {
            setBannerEnd(true);
        }
    });
    //listen to banner end event from Banner.tsx
    (0, hooks_1.useEffect)(function () {
        window.addEventListener('bannerEnd', function () {
            setBannerEnd(true);
        });
    });
    var ctaText = ((0, preact_1.h)("p", null,
        "ADD TO CART -",
        ' ',
        ((_b = prices.compareAtPrice) === null || _b === void 0 ? void 0 : _b.amount) && +prices.compareAtPrice.amount > 0 && ((0, preact_1.h)("span", { class: "shop-v2__price-original" }, (0, hydrogen_react_1.useMoney)(prices.compareAtPrice).withoutTrailingZeros)),
        ' ',
        prices.price && (0, hydrogen_react_1.useMoney)(prices.price).withoutTrailingZeros));
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "shop-v2__cta-container" },
            (0, preact_1.h)(CtaButton_1.default, { text: ctaText, backgroundColor: {
                    to: 'Left',
                    startColor: colors.ctaBgColor || 'white',
                    endColor: colors.ctaBgColor || 'white',
                }, hoverColor: "white", handleClick: function () { return handleAddToCart(); }, size: "large" })),
        window.isDiscountPriceABTest && ((0, preact_1.h)("p", { class: "price-with-discount" },
            "Only ",
            (0, preact_1.h)("strong", null,
                "$",
                discountPrice),
            " with code ",
            (0, preact_1.h)("span", null, discount)))));
};
exports.default = ShopCta;
